export class facetModel {
  constructor() {
    this.code = null;
    this.values = {};
  }
  code: string;

  values: { [key: string]: number };
}
